// Business hours for a location. Each day is one of three states:
//   closed              → closed: true
//   open 24 hours       → closed: false, open24: true
//   bounded open/close  → closed: false, open24: false, openTime/closeTime set
// A day whose closeTime is earlier than its openTime runs overnight and closes
// on the following calendar day (e.g. 20:00 – 02:00).

export const DAYS_OF_WEEK = [
	'MONDAY',
	'TUESDAY',
	'WEDNESDAY',
	'THURSDAY',
	'FRIDAY',
	'SATURDAY',
	'SUNDAY',
] as const;

export type DayOfWeek = (typeof DAYS_OF_WEEK)[number];

export interface BusinessHoursDay {
	dayOfWeek: DayOfWeek;
	closed: boolean;
	open24: boolean;
	openTime: string;
	closeTime: string;
}

export interface UpdateBusinessHoursRequest {
	days: BusinessHoursDay[];
}

/**
 * A booking that no longer sits inside the location's opening hours after a
 * save. Saving hours never cancels anything — these are reported back purely
 * so the provider can decide what to do with each one.
 */
export interface AffectedBooking {
	appointmentId: number;
	appointmentDateTime: string;
	/** Server-formatted for display, e.g. "Sep 12, 12:00 AM". */
	whenLabel: string;
	serviceName: string | null;
	durationMinutes: number | null;
	locationId: number;
	locationName: string | null;
	staffId: number | null;
	staffName: string | null;
	status: string | null;
}

/**
 * The PUT echoes the saved week back wrapped in `days`, unlike the GET which
 * still sends a bare array. `warning` and `affectedBookings` are only present
 * when the new hours leave existing bookings outside the open window.
 */
export interface BusinessHoursUpdateResponse {
	days: BusinessHoursDay[];
	warning?: string | null;
	affectedBookings?: AffectedBooking[] | null;
}
